// src/config.js
const API_URL = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:5002';

export default API_URL;